import * as angular from 'angular';
import { PlannedGraduationDropdownComponent } from './planned-graduation-dropdown.component';

export const PlannedGraduationDropdownModule = angular
  .module('plannedGraduationDropdownModule', [])
  .component('plannedGraduationDropdown', PlannedGraduationDropdownComponent).name;
